import React, { Component } from 'react';

class TFAVerify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      qrsrc: "",
      code_input: ""
    }
  }

  handleCodeInputChange = (event) => {
    this.setState({code_input: event.target.value})
  }

  setupTFA = () => {
    let username = this.props.username;
    fetch('/api/getqrExistingUser', {
      method: "POST",
      body: JSON.stringify({username:username}),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(r =>  r.json().then(data => ({res: r, body: data})))
    .then(obj => {
      if(!obj.res.ok) throw Error(obj.res.statusText);
      else{
        if(obj.body === undefined || obj.body === null) console.log("No QR data to display");
        else this.setState({qrsrc: obj.body, hidden:false})
      }

    })
    .catch(function(error) {
      console.log(error);
    });
  }

  verifyCode = () =>{;
    let code = this.state.code_input;
    fetch('/api/verifyCode', {
      method: "POST",
      body: JSON.stringify({code:code}),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then((res) => {
      if(!res.ok){
        if(res.status === 401) alert("Could not verify TFA code for user")
        else{
          alert("Error Verifying TFA for user");
          throw Error(res.statusText);
        }
      }
      else{
        alert("TFA verified for user.");
        this.props.cancelEditUser();
      }

    }).catch(function(error) {
      console.log(error);
    });
  }

  render = () => {
    return (
      <div>
        <div className="form-group">
          <label className="col-md-4 control-label">TFA</label>
          <div className="col-md-8">
            <div className="row"><div className="col-md-6"><button type="button" className="btn btn-light"  onClick={() => this.setupTFA()} >setup TFA</button></div><div className="col-md-12"></div></div>
          </div>
        </div>

        <div className="form-group" style={{display: this.state.hidden ? 'none' : 'block'}}>
          <label className="col-md-4 control-label"></label>
          <div className="col-md-8">
            <div className="row"><div className="col-md-12"><img src = {this.state.qrsrc} alt="this is a problem"></img></div></div>
            <div className="row">
              <div className="col-md-4">
                <input 
                  id="codeInput"
                  name="codeInput"
                  type="text"
                  placeholder="Enter Code"
                  className="form-control input-md"
                  value={this.state.code_input}
                  onChange={this.handleCodeInputChange}
                />
              </div>
              <div className="col-md-4">
                <button type="button" className="btn btn-light"  onClick={() => this.verifyCode() }>Verify</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TFAVerify;


// WEBPACK FOOTER //
// ./src/Components/Form/TFAVerification.js